var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"notice",attrs:{"width":"35%","title":_vm.$t('MN_F_4'),"visible":_vm.noticeFlag},on:{"update:visible":function($event){_vm.noticeFlag=$event},"close":_vm.closeTap}},[_c('div',{staticClass:"img-auto",domProps:{"innerHTML":_vm._s(_vm.content.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }